var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyVenuesIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 41,
    viewBox: "0 0 48 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5267 0H9.79961C5.73428 0 3.69141 2.06089 3.69141 6.16227V38.7692H14.7229V31.1174C14.7229 30.2808 15.4175 29.587 16.2551 29.587C17.0927 29.587 17.7873 30.2604 17.7873 31.1174V38.7692H28.6145V6.16227C28.6145 2.06089 26.592 0 22.5267 0ZM21.3623 19.8947H11.2501C10.4125 19.8947 9.71789 19.201 9.71789 18.3644C9.71789 17.5278 10.4125 16.834 11.2501 16.834H21.3623C22.1999 16.834 22.8944 17.5278 22.8944 18.3644C22.8944 19.201 22.1999 19.8947 21.3623 19.8947ZM21.3623 12.2429H11.2501C10.4125 12.2429 9.71789 11.5491 9.71789 10.7126C9.71789 9.87595 10.4125 9.18219 11.2501 9.18219H21.3623C22.1999 9.18219 22.8944 9.87595 22.8944 10.7126C22.8944 11.5491 22.1999 12.2429 21.3623 12.2429Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4681 37.487H41.8315V31.2724C43.7719 30.6302 45.1813 28.7865 45.1813 26.6114V22.4683C45.1813 19.7546 42.9957 17.5381 40.32 17.5381C37.6443 17.5381 35.4587 19.7546 35.4587 22.4683V26.6114C35.4587 28.7658 36.8477 30.5888 38.7472 31.2517V37.487H1.53191C0.694468 37.487 0 38.1913 0 39.0406C0 39.89 0.694468 40.5943 1.53191 40.5943H40.1974C40.2383 40.5943 40.2587 40.615 40.2996 40.615C40.3404 40.615 40.3609 40.5943 40.4017 40.5943H46.4681C47.3055 40.5943 48 39.89 48 39.0406C48 38.1913 47.3055 37.487 46.4681 37.487Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyVenuesIcon);
export default __webpack_public_path__ + "static/media/MyVenues_icon.cb529be02ec544bc3f38a691f45156ef.svg";
export { ForwardRef as ReactComponent };